// extracted by mini-css-extract-plugin
export default {"Landing":"Landing_Landing__C9m8+"};